import React from "react";
import "./Place.css";

const Place = ({ title, image, url, urlText, texts }) => {
  return (
    <article className="place">
      <div className="place__header">
        <h2 className="place__title">{title}</h2>
        <img className="place__image" src={image} alt={title} />
      </div>
      <div className="place__content">
        <div className="place__url">
          <h3 className="place__url-heading">url</h3>
          <a
            className="place__url-link"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {urlText}
          </a>
        </div>
        <div className="place__texts">
          {texts.map((text, index) => (
            <p key={index} className="place__text">
              {text}
            </p>
          ))}
        </div>
      </div>
    </article>
  );
};

export default Place;
